import type { AppRouteModule } from '@/router/types';

import { LAYOUT } from '@/router/constant';
import { RoleEnum } from '@/enums/roleEnum';

const Business: AppRouteModule = {
  path: '/purchaseManage',
  name: 'PurchaseManage',
  identify: 'purchaseManage',
  component: LAYOUT,
  redirect: '/purchaseManage/purchaseOrder',
  meta: {
    icon: 'bx:purchase-tag',
    title: '采购管理',
    roles: [RoleEnum.OFFLINE],
  },
  children: [
    {
      path: 'purchaseOrder',
      name: 'PurchaseOrder',
      identify: 'purchaseOrder',
      component: () => import('@/views/purchaseManage/purchaseOrder/index.vue'),
      meta: {
        title: '采购订货',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'purchaseOrder/add',
      name: 'PurchaseOrderAdd',
      identify: 'purchaseOrder',
      component: () => import('@/views/purchaseManage/purchaseOrder/add.vue'),
      meta: {
        title: '新建订货单',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/purchaseManage/purchaseOrder',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'purchaseReturn',
      name: 'PurchaseReturnPage',
      identify: 'purchaseReturnPage',
      component: () => import('@/views/purchaseManage/purchaseReturn/index.vue'),
      meta: {
        title: '采购退货',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'purchaseReturn/:pageType/:orderNum?',
      name: 'PurchaseReturnAddPage',
      identify: 'purchaseReturnPage',
      component: () => import('@/views/purchaseManage/purchaseReturn/add.vue'),
      meta: {
        title: '新建采购退货单',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/purchaseManage/purchaseReturn',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'purchaseExchange',
      name: 'PurchaseExchangePage',
      identify: 'purchaseExchangePage',
      component: () => import('@/views/purchaseManage/purchaseExchange/index.vue'),
      meta: {
        title: '采购换货',
        roles: [RoleEnum.OFFLINE],
      },
    },
    {
      path: 'purchaseExchange/:pageType/:orderNum?',
      name: 'PurchaseExchangeAddPage',
      identify: 'purchaseExchangePage',
      component: () => import('@/views/purchaseManage/purchaseExchange/add.vue'),
      meta: {
        title: '新建采购换货单',
        hideMenu: true,
        hideTab: true,
        currentActiveMenu: '/purchaseManage/purchaseExchange',
        roles: [RoleEnum.OFFLINE],
      },
    },
  ],
};

export default Business;
